import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=60e12e0c&scoped=true&"
import script from "./CouponList.vue?vue&type=script&lang=ts&"
export * from "./CouponList.vue?vue&type=script&lang=ts&"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=60e12e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e12e0c",
  null
  
)

export default component.exports